// Dealer.com Custom Plugin
((WIAPI) => {
  const API = new WIAPI();
  const _CS_DISABLED_DEALER_IDS_KEY = "cs-dealercom-disabled-dealers-v1";
  const viewOptions = {
    wide: "max-width: calc(3 / 4 * 100vw); min-width: 576px;",
    quarter: "max-width: 420px;",
  };
  const defaultView = viewOptions.quarter;
  let wideViewEnabled = null;
  let viewOptionStyle = defaultView;
  let selectedVehicle = null;
  let thirdPartyCookiesEnabled = null;
  const trustedOrigins = [
        "https://nissanathome.carsaver.com",
        "https://nissanathome.beta.carsaver.com",
        "http://localhost:3001",
        "http://localhost:8080",
      ];

  API.log("Started CS Plugin");

  cookieTest("https://shopathome.carsaver.com/cookietest", (message) => {
    if (message && "cscookieresult" in message) {
      thirdPartyCookiesEnabled = message.cscookieresult;
    }
  });

  API.subscribe("page-load-v1", (ev) => {
    // Only execute the code on search results and vehicle details pages.
    if (ev.payload.searchPage || ev.payload.detailPage) {
      const _CS_CAMPAIGN_ID =
        process.env.CAMPAIGN_ID || "ebd33059-445a-4cde-b74a-35cb068680a6";
      const _CS_API_BASE_URL =
        process.env.API_BASE_URL || "https://api.carsaver.com";
      const urlParams = API.utils.getUrlParams();
      const _CS_TEST_ENABLED = urlParams?._CS_TEST_ENABLED || false;
      let nnaDealerId;

      API.subscribe("dealership-info-v1", (ev) => {
        nnaDealerId = ev.payload.dealershipCodes?.nissanoem;
      });

      API.subscribe("vehicle-data-updated-v1", function (data) {
        if (!_CS_TEST_ENABLED && (!nnaDealerId || nnaDealerId === "")) {
          API.log("No NNA Dealer ID Found");
          return;
        }

        const myStorage = window.sessionStorage;

        const storageDisabledDealerIds = JSON.parse(
          myStorage.getItem(_CS_DISABLED_DEALER_IDS_KEY) || "[]"
        );

        if (storageDisabledDealerIds?.indexOf(nnaDealerId) !== -1) {
          API.log("Disabling button due to session disablement.");

          return;
        }

        API.utils.getConfig().then((config) => {
          let btnType = config?.btnType;

          API.utils.getAttributeForVehicles("vin").then((vins) => {
            const listOfVins = vins.join(",");
            API.log("Calling service with these VINs: " + listOfVins);

            const domain = encodeURIComponent(location.hostname);
            const widgetReferrer = encodeURIComponent(location.href);
            const apiUrl = `${_CS_API_BASE_URL}/apex/dealerplugin/v2/vehicle/active`;
            const queryParams = {
              dealerId: nnaDealerId,
              provider: "nissan",
              campaignId: _CS_CAMPAIGN_ID,
              domain: domain,
              vins: listOfVins,
              widgetReferrer: widgetReferrer,
            };
            const queryString = Object.entries(queryParams)
              .map(([key, value]) => `${key}=${value}`)
              .join("&");
            const fullUrl = `${apiUrl}?${queryString}`;

            fetch(fullUrl)
              .then((response) => {
                return response.json();
              })
              .then((serviceData) => {
                // if overlay is not enabled or default target is _blank
                let target = "_blank";
                Object.values(serviceData).forEach((buttonArray) => {
                  buttonArray.forEach((button) => {
                    if(button.active && wideViewEnabled === null) {
                        wideViewEnabled = button.wideViewEnabled;
                    }

                    if (button.overlayEnabled) {
                      if (thirdPartyCookiesEnabled) {
                        // If third party cookies are enabled build buttons with overlay iframe
                        target = null;
                      } else {
                        // If third party cookies are not enabled build buttons with target self
                        target = "_self";
                      }
                    }

                    buildButtons(
                      button,
                      _CS_TEST_ENABLED,
                      API,
                      btnType,
                      target,
                      nnaDealerId
                    );
                  });
                });
              });
          });
        });
      });
    }
  });

  function disableDealerId(dealerId) {
    const myStorage = window.sessionStorage;
    const disabledIds = JSON.parse(
      myStorage.getItem(_CS_DISABLED_DEALER_IDS_KEY) || "[]"
    );
    if (disabledIds.indexOf(dealerId) === -1) {
      disabledIds.push(dealerId);
      myStorage.setItem(
        _CS_DISABLED_DEALER_IDS_KEY,
        JSON.stringify(disabledIds)
      );
    }
  }

  function createOverlayContainer() {
    const overlayContainer = document.createElement("div");
    overlayContainer.classList.add("csw-overlay");
    overlayContainer.style.cssText =
      "width: 100%; position: fixed; top: 0; right: 0; bottom: 0; z-index: 9999999999; background-color: rgba(0,0,0,.5);";
    overlayContainer.addEventListener("click", outsideClickEvent);
    return overlayContainer;
  }

  function createModalContainer() {
    const modalContainer = document.createElement("div");

    viewOptionStyle = wideViewEnabled ? viewOptions.wide : viewOptions.quarter;
    modalContainer.classList.add("csw-modal-container");

    // Check screen width and apply styles accordingly
    if (window.innerWidth <= 576) {
      modalContainer.style.cssText =
        "right: 0; height: 100%; width: 100%; max-width: unset; position: absolute; background-color: #f6f6f6;";
    } else {
      modalContainer.style.cssText =
        `right: 0; height: 100%; width: 100%; ${viewOptionStyle} position: absolute; background-color: #f6f6f6;`;
    }

    return modalContainer;
  }

  function createModal(url) {
    const modal = document.createElement("div");
    modal.classList.add("csw-modal");
    modal.style.cssText = "width: 100%; height: 100%; overflow: hidden;";

    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.width = "100%";
    iframe.height = "95%";
    iframe.style.border = "none";
    iframe.style.height = "95%";
    iframe.style.width = "100%";
    iframe.classList.add("csw-iframe");

    modal.appendChild(iframe);
    return modal;
  }

  function createCloseBanner(onClose) {
    const closeBanner = document.createElement("div");
    closeBanner.classList.add("csw-modal-close-container");
    closeBanner.style.cssText =
      "display: flex; min-height: 21px; align-items: center; justify-content: flex-end; padding: 12px 24px; cursor: pointer; background-color: #fff;";

    const closeButton = document.createElement("a");
    closeButton.classList.add("csw-modal-close-link");
    closeButton.innerText = "X";
    closeButton.style.cssText = "font-size: 14px; text-decoration: none;";
    closeButton.addEventListener("click", onClose);

    closeBanner.appendChild(closeButton);
    return closeBanner;
  }

  function outsideClickEvent(event) {
    if (event.target.classList.contains("csw-overlay")) {
      unsavedFormInquiry();
    }
  }

  function cookieTest(iFrameUri, callBack) {
    let messageHandler = (event) => {
      const data = event.data;
      const clonedData = { ...data };
      callBack(clonedData);

      // Check if the received message has the key cscookieresult
      if ("cscookieresult" in clonedData) {
        // remove event listener after receiving cookie test result
        window.removeEventListener("message", messageHandler);
        document.body.removeChild(frame);
      }
    };
    window.addEventListener("message", messageHandler);
    const frame = document.createElement("iframe");
    frame.id = "cookietestiframe";
    frame.src = iFrameUri;
    frame.sandbox = "allow-scripts allow-same-origin";
    frame.style = `display:none`;
    document.body.appendChild(frame);
  }

  function handleOverlay(button, url) {
    window.addEventListener("message", messageHandler, false);
    selectedVehicle = button;
    console.log("Selected Vehicle:", selectedVehicle);
    const overlayContainer = createOverlayContainer();
    const modalContainer = createModalContainer();
    const modal = createModal(url);

    const closeBanner = createCloseBanner(() => {
      unsavedFormInquiry();
    });

    modalContainer.appendChild(closeBanner);
    modalContainer.appendChild(modal);
    overlayContainer.appendChild(modalContainer);
    document.body.appendChild(overlayContainer);
  }

  function determineIntent(ctaType) {
    // dealer .com has certain intents you need to set per button type
    let intent = "eprice";
    if (ctaType === "trade") {
      intent = "value-a-trade";
    } else if (ctaType === "pre-approved") {
      intent = "pre-approval";
    }
    return intent;
  }

  function shouldNissanFontBeInjected(ctaFont) {
    if (ctaFont.toLowerCase().trim() === "nissanbrand") {

      const regularFont = new FontFace(
          "nissanbrand",
          "url(https://nissan-brand-fonts.carsaver.com/nissan-brand-regular.otf)",
          { weight: "400", style: "normal" }
      );

      const boldFont = new FontFace(
          "nissanbrand",
          "url(https://nissan-brand-fonts.carsaver.com/nissan-brand-bold.otf)",
          { weight: "700", style: "normal" }
      );

      // Load and add the regular font
      regularFont.load()
          .then((font) => {
            document.fonts.add(font);
          })
          .catch((err) => console.error("Error loading nissan brand regular font:", err));

      // Load and add the bold font
      boldFont.load()
          .then((font) => {
            document.fonts.add(font);
          }).catch((err) => console.error("Error loading nissan brand bold font:", err));
    }
  }

  function buildButtons(
    button,
    _CS_TEST_ENABLED,
    API,
    btnType,
    target,
    dealerId
  ) {
    const intent = determineIntent(button.ctaType);
    // Insert content into each vehicle location now present on the page.
    API.insertCallToActionOnce("button", intent, (meta) => {
      if (
        (button.active && button.style.active && button.vin === meta.vin) ||
        _CS_TEST_ENABLED
      ) {
        API.log(meta);

        const { style } = button;
        // Check if Nissan font should be injected
        shouldNissanFontBeInjected(style.font);

        // Create CSS style string
        let cssStyle = "";

        if (button.ctaType === "primary") {
          // users can't change primary cta color
          cssStyle += "color: #FFFFFF;";
        } else {
          cssStyle += "color: " + style.color + "; ";
        }

        cssStyle += "font-weight: " + style.fontWeight + "; ";
        cssStyle += "background-color: " + style.backgroundColor + "; ";
        cssStyle += "width: " + style.width + "; ";
        cssStyle += "height: " + style.height + "; ";
        cssStyle += "font-family: " + style.font + "; ";
        cssStyle += "font-size: " + style.fontSize + "; ";
        cssStyle += "text-align: " + style.textAlign + "; ";
        cssStyle += "padding: " + style.padding + "; ";
        cssStyle += "margin: " + style.margin + "; ";
        cssStyle += "border-radius: " + style.borderRadius + ";";
        const utmParams = `&utm_source=dealercom-plugin&utm_medium=buy-button&utm_content=${style.name}`;
        // Split the URL by '#'
        const parts = button.entryPoint.split('#');
        // Extract the URL and the fragment (e.g., "Payment")
        const base = parts[0];
        const fragment = parts[1];
        // Join the utmParams with the URL
        const newURL = base + utmParams;
        // Join the new URL with the anchor, ensuring #Payment is at the end
        const url = fragment ? newURL + '#' + fragment : newURL;
        let ctaObject = {};
        if (target === null) {
          // If target is null, add onclick to ctaObject
          ctaObject = {
            type: btnType || "primary",
            onclick: () => {
              handleOverlay(button, url);
            },
            text: style.name || "Buy@Home",
            style: cssStyle,
            attributes: {
              onmouseover: `this.style.backgroundColor='${button.style.hoverBackgroundColor}'; this.style.color='#FFFFFF';`,
              onmouseout: `this.style.backgroundColor='${
                button.style.backgroundColor
              }'; this.style.color='${
                button.ctaType === "primary" ? "#FFFFFF" : style.color
              }';`,
            },
          };
        } else {
          // If target is not null, add href & target to ctaObject
          ctaObject = {
            type: btnType || "primary",
            href: url,
            target: target,
            text: style.name || "Buy@Home",
            style: cssStyle,
            attributes: {
              onmouseover: `this.style.backgroundColor='${button.style.hoverBackgroundColor}'; this.style.color='#FFFFFF';`,
              onmouseout: `this.style.backgroundColor='${
                button.style.backgroundColor
              }'; this.style.color='${
                button.ctaType === "primary" ? "#FFFFFF" : style.color
              }';`,
            },
          };
        }

        return ctaObject;
      } else {
        // Check and disabled dealer ID if needed
        const { message = "", dealerEnabled = true } = button[meta.vin] || {};

        if (!dealerEnabled) {
          API.log(`Disabling button for session due to: ${message}`);

          disableDealerId(dealerId);
        }
      }
    });
  }

  function unsavedFormInquiry() {
    const iframe = document.querySelector(".csw-iframe");
    const message = { action: "unsaved-form-inquiry" };

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(message, "*");
    }
  }

  function closeModal(event) {
    // Reset the selectedVehicle to null when the modal is closed
    selectedVehicle = null;
    console.log("Clear Selected Vehicle:", selectedVehicle);
    // Remove the message event listener when the modal is closed
    window.removeEventListener("message", messageHandler);
    // Remove the modal from the DOM
    const overlayContainer = document.querySelector(".csw-overlay");
    if (overlayContainer) {
      document.body.removeChild(overlayContainer);
    }
  }

  function overlayHandler(eventData) {
    const overlayType = eventData.type.toLowerCase().trim();

    if (overlayType === "close") {
      closeModal(eventData);
    }
  }

  function unsavedFormResponseHandler(eventData) {
    const unsavedData = !!eventData.response || false;

    if (unsavedData) {
      return;
    }

    closeModal(eventData);
  }

  function messageHandler(event) {
    const fromTrustedOrigin = trustedOrigins.includes(event.origin);
    const actionTypeString = typeof (event.data && event.data.action) === "string";
    let actionType = null;
    if (!fromTrustedOrigin || !actionTypeString) {
      return;
    }

    actionType = event.data.action.toLowerCase().trim();

    switch (actionType) {
      case "overlay":
        overlayHandler(event.data);
        break;
      case "unsaved-form-response":
        unsavedFormResponseHandler(event.data);
        break;
      default:
        break;
    }
  }

})(window.DDC.API);
